import { render } from "./CaseAttachments.vue?vue&type=template&id=7ddf6c2a"
import script from "./CaseAttachments.vue?vue&type=script&lang=js"
export * from "./CaseAttachments.vue?vue&type=script&lang=js"

import "./CaseAttachments.vue?vue&type=style&index=0&id=7ddf6c2a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QVideo from 'quasar/src/components/video/QVideo.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QList,QItem,QItemSection,QBtn,QImg,QVideo});
